<td #tdElement class="nz-disable-td" style="padding: 0px; border: 0px; height: 0px" *ngFor="let th of listOfMeasureColumn; trackBy: trackByFunc"></td>
